<template>
   <ValidationObserver rules="required" >
    <RightSideBar @close="$emit('close')" button-class="bg-dynamicBackBtn text-white"
      :disabled-button="reliefType === 'rent' ? !(reliefType && reliefsAmount && rentStartDate && rentEndDate && file.length > 0) :
        !(reliefType && reliefsAmount && file.length > 0)"
      :submit="'Save'" :cancel="'Cancel'" @submit="submitReliefs"
    >
      <template v-slot:title>
        <p class="text-darkPurple flex gap-5 items-center cursor-pointer">
          Add relief
        </p>
      </template>
      <p class="my-6 text-jet text-base">
        Enter details of your eligible relief (e.g., rent, life assurance, or annuity)
        and upload supporting evidence for validation.
      </p>
      <div class="w-full flex flex-col gap-1 text-jet text-sm">
        <p>Relief type</p>
        <c-select placeholder="--Select--"
          variant="w-full h-10"
          :options="reliefsOptions" v-model="reliefType"
        />
      </div>

      <div v-if="reliefType === 'rent'" class="my-6 text-jet text-sm">
        <c-text label="How much is your annual rent?"
          placeholder="Enter" type="number" v-model="reliefsAmount"
        />
        <div class="flex justify-between items-center gap-2 mt-6">
          <div class="w-1/2">
            <label class="date-label">Start Date </label>
            <div class="date-flex">
              <datepicker
                placeholder="--Select--"
                style="width: 100%; outline: none"
                input-class="date-input"
                format="MMMM d, yyyy"
                v-model="rentStartDate"
              />
            </div>
          </div>
          <div class="w-1/2">
            <label class="date-label"> End Date </label>
            <div class="date-flex bg-disabled">
              <datepicker
                placeholder="--Select--"
                style="width: 100%; outline: none"
                input-class="date-input"
                format="MMMM d, yyyy"
                v-model="rentEndDate"
                :disabled-dates="{ to: new Date(rentStartDate) }"
              />
            </div>
          </div>
        </div>
        <div class="line"></div>
        <p>Upload evidence (E.g Rent receipt or lease agreement)</p>
      </div>

      <div v-if="reliefType === 'lifeAssurance'" class="my-6 text-jet text-sm">
        <c-text label="How much is your annual premium?"
          placeholder="Enter" type="number" v-model="reliefsAmount"
        />
        <div class="line"></div>
        <p>Upload evidence (E.g Life assurance contract)</p>
      </div>

      <div v-if="reliefType === 'deferredAnnuity'" class="my-6 text-jet text-sm">
        <c-text label="How much is your annual premium?"
          placeholder="Enter" type="number" v-model="reliefsAmount"
        />
        <div class="line"></div>
        <p>Upload evidence (E.g Deferred annuity contract)</p>
      </div>

      <div v-if="reliefType === 'lifeAssurance' || reliefType === 'deferredAnnuity' || reliefType === 'rent'"
        class="w-full h-10 bg-color pl-3 mt-6 flex justify-center items-center"
      >
        <div v-if="file.length === 0 && !uploading">
          <input type="file" @change="handleInputFiles" ref="fileInput" hidden>
          <div @click="triggerInputFile"
            class="w-full h-full m-auto text-base text-dynamicBackBtn font-normal cursor-pointer flex justify-center items-center gap-1"
          >
            <Icon icon-name="upload-icon-red" size="s" />
            <p>Upload</p>
          </div>
        </div>
        <div v-if="uploading"
          class="text-base text-dynamicBackBtn font-normal cursor-pointer flex justify-center items-center"
        >
          Uploading...
        </div>
        <div v-if="file.length > 0" class="w-full">
          <div v-for="(item, index) in file" :key="index"
            class="w-full flex justify-between items-center gap-6"
          >
            <div class="w-auto h-full flex justify-start items-center">
              <div class="w-9">
                <icon icon-name="pdf" size="xs" class="icon" v-if="item.mimeType === 'pdf'"/>
                <icon icon-name="doc" size="xs" class="icon" v-else-if="item.mimeType === 'doc'"/>
                <icon icon-name="xlsx" size="xs" class="icon" v-else-if="item.mimeType === 'xlsx'"/>
                <icon icon-name="csv" size="xs" class="icon" v-else-if="item.mimeType === 'csv'"/>
                <icon icon-name="ppt" size="xs" class="icon" v-else-if="item.mimeType === 'ppt'"/>
                <icon icon-name="png" size="xs" class="icon" v-else-if="item.mimeType === 'png'"/>
                <icon icon-name="jpg" size="xs" class="icon" v-else-if="item.mimeType === 'jpg'"/>
                <icon icon-name="jpg" size="xs" class="icon" v-else-if="item.mimeType === 'jpeg'"/>
              </div>

              <div class="flex justify-center items-start gap-2">
                <p class="text-blackJet text-sm">
                  {{ item.fileName }}.{{ item.mimeType }}
                </p>
                <p class="text-xs text-romanSilver mt-1">
                    • {{ item.fileSize.toFixed(2) }}
                </p>
              </div>
            </div>
            <div @click="deleteUploadedFile()" class="cursor-pointer h-full w-9">
              <icon icon-name="trash-icon" size="s" class="icon"/>
            </div>
          </div>
        </div>
      </div>
    </RightSideBar>
  </ValidationObserver>
</template>

<script>
  import axios from 'axios';
  import { ValidationObserver } from "vee-validate";
  import RightSideBar from "@/components/RightSideBar";
  import CSelect from "@scelloo/cloudenly-ui/src/components/select";
  import CText from "@scelloo/cloudenly-ui/src/components/text";
  import Datepicker from "vuejs-datepicker";

  export default {
    name: "AddReliefs",
    components: {
      ValidationObserver,
      RightSideBar,
      CSelect,
      CText,
      Datepicker
    },
    props: {
    },
    data() {
      return {
        reliefType: '',
        reliefsAmount: '',
        reliefsOptions: [
          { id: "rent", name: "Rent" },
          { id: "lifeAssurance", name: "Life Assurance" },
          { id: "deferredAnnuity", name: "Deferred Annuity" }
        ],
        mimeType: {
          "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
          "vnd.openxmlformats-officedocument.wordprocessingml.document": "doc",
          "vnd.openxmlformats-officedocument.presentationml.presentation": "ppt",
          "vnd.ms-powerpoint": "ppt",
          "pptx": "ppt"
        },
        imageSizeMB: 0,
        uploading: false,
        file: [],
        rentStartDate: '',
        rentEndDate: '',
        isLoading: false
      };
    },
    methods: {
      triggerInputFile() {
        this.$refs.fileInput.click();
      },
      handleInputFiles() {
        const { files } = this.$refs.fileInput;
        const arrayfiles = Array.from(files);

        if(arrayfiles > 1){
          return this.$toasted.error("You can't upload more than 1 file.",
            { duration: 6000,}
          );
        }
        return this.validateAndUploadFile(files[0])
      },
      validateAndUploadFile(file) {
        const extension = file.type.split('/').pop().toLowerCase(); // Extract and format file type
        const type = this.mimeType[extension] || extension;
        this.fileType = type;
        const allowedFileType = [ "pdf", "doc", "xlsx", "csv", "ppt", "png", "jpg", "jpeg", "sheet"]

        if(!allowedFileType.includes(type)){
          return this.$toasted.error("Unsupported file type.", { duration: 6000 });
        }
        return this.uploadImage(file);
      },
      async uploadImage(file) {
        if (!file) return;

        this.uploading = true;
        const payload = {
          fileName: file.name,
          fileType: file.type,
          fileSize: file.size
        }
        try{
          const { data } = await this.$_uploadLargerFile(payload);
          await axios.put(data.uploadUrl, file, { headers: {
              'Content-Type': file.type,
            }
          });
          const { name } = file;
          const fName = name.substr(0, name.lastIndexOf(".")).replace(/[\d()-]+/g, '');
          const fileExtension = file.type.split('/').pop().toLowerCase();
          const type = this.mimeType[fileExtension] || fileExtension;
          this.file.push({
              fileUrl: data.fileUrl,
              fileSize: file.size,
              mimeType: type,
              fileName: fName,
            });
          this.uploading = false;
        }catch(error){
            this.uploading = false;
        };
      },
      deleteUploadedFile() {
        this.file = [];
      },
      formatDateToYMD(date) {
        if(date){
          const yyyy = date?.getFullYear();
          const mm = String(date?.getMonth() + 1).padStart(2, '0');
          const dd = String(date?.getDate()).padStart(2, '0');
          return `${yyyy}-${mm}-${dd}`;
        }
        return null;
      },
      async submitReliefs() {
        const typeMap = {
          rent: "Rent",
          lifeAssurance: "Life Assurance",
          deferredAnnuity: "Deferred Annuity",
        };
        const payload = {
          name: typeMap[this.reliefType] || "",
          reliefType: this.reliefType,
          amount: this.reliefsAmount,
          startDate: this.formatDateToYMD(this.rentStartDate),
          endDate: this.formatDateToYMD(this.rentEndDate),
          fileUrl: this.file ? this.file[0]?.fileUrl : ' ',
          fileSize: this.file ? (this.file[0]?.fileSize / 1024).toString() : ' ',
          fileName: this.file ? this.file[0]?.fileName : ' ',
          fileMimeType: this.file ? this.file[0]?.mimeType : ' '
        }
        this.isLoading = true;
        try {
          await this.$_postEmployeeReliefs(payload, this.$AuthUser.id);
          this.$emit('refresh');
          this.$emit('close')
          this.isLoading = false;
          return this.$toasted.success("Employee relief added successfully", { duration: 5000 });
        } catch (error) {
          this.isLoading = false;
          return this.$toasted.error(error.response.data.message, { duration: 5000 });
        }
      },
    }
  };
</script>

<style scoped>
.line{
  border: 0.5px solid #00000029;
  width: 100%;
  height: 0;
  margin: 24px auto;
  border-radius: 10px;
  padding: 0;
}
.bg-color{
  background: #FBFBFB;
}
</style>
